// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { InstrumentConfiguration } from '@digitalasset/utility-operator-api-ts-client';

type OverlapParams = {
  tokenName: string;
  tokenSymbol: string;
  cusip: string;
  excludeId?: string;
};

// Returns an existing instrument that overlaps with the provided details, if any.
// Overlap = same token name + symbol, or the same CUSIP.
export const findOverlappingInstrument = (
  configs: InstrumentConfiguration[] | undefined,
  { tokenName, tokenSymbol, cusip, excludeId }: OverlapParams,
): InstrumentConfiguration | undefined => {
  if (!configs) return undefined;
  return configs.find((config) => {
    if (excludeId && config.payload.defaultIdentifier.id === excludeId) return false;
    const nameSymbolMatch =
      !!tokenName &&
      !!tokenSymbol &&
      config.payload.tokenName === tokenName &&
      config.payload.tokenSymbol === tokenSymbol;
    const cusipMatch = !!cusip && config.payload.cusip === cusip;
    return nameSymbolMatch || cusipMatch;
  });
};

export const getInstrumentOverlapWarning = (
  configs: InstrumentConfiguration[] | undefined,
  params: OverlapParams,
): string => {
  const match = findOverlappingInstrument(configs, params);
  if (!match) return '';
  return `An instrument with these details already exists (name "${match.payload.tokenName}", symbol "${match.payload.tokenSymbol}", CUSIP "${match.payload.cusip}").`;
};
